import React from 'react';
import { useNewStartGsapTestMutation } from './NewGsapQuizSlice';
import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

type instructionsProps = {
  data: any;
};

const GsapAptitudeInstructions = (props: instructionsProps) => {
  const [loading, setLoading] = useState(false);
  // changed this: useNewStartAptitudeTestMutation , according to new aptitude slice
  const [startAptitudeTest] = useNewStartGsapTestMutation();
  function startAptitude() {
    setLoading(true);
    startAptitudeTest({ responses: props.data });
  }
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }
  return (
    <>
      <div className='mb-8'>
        <div className='m-1 sm:m-8 bg-gray-50/50 p-2 sm:p-8'>
          <div className='text-primary font-semibold mb-4 mt-4'>
            General Instructions
          </div>
          <div className='mb-2 sm:mb-6'>
            <div>
              This Aptitude Test is designed to holistically evaluate your
              readiness for real-world challenges across various domains. It
              will assess your critical thinking and problem-solving abilities,
              communication skills, and creativity and innovation. The test also
              measures how well you demonstrate collaboration and teamwork,
              leadership and initiative, and self-management and accountability.
              In addition, your ability to show emotional intelligence and
              empathy as well as an entrepreneurial mindset will be evaluated
              through different types of questions.
            </div>
            <div>
              You are expected to apply logic, express ideas clearly, make
              informed decisions, and reflect a proactive attitude—skills that
              are essential for both academic and professional growth.
            </div>
          </div>
          <div className='ml-2'>
            <div className='text-primary font-semibold mb-4 mt-4'>
              Instructions
            </div>
            <ul className='list-disc ml-4 sm:ml-6'>
              <li>Click on "Start Test" to begin the assessment</li>
              <li>
                You can navigate through questions using Previous/ Next Buttons
              </li>
              <li>
                You will have a total of 20 minutes to complete the assessment.
              </li>
              <li>
                If you finish early, you may review and edit your responses
                before submitting.
              </li>
              <li>
                When the timer ends, your answers will be auto-submitted if not
                already submitted manually.
              </li>
              <li>Your score will be displayed upon submission.</li>
            </ul>
            <div className='mt-2 sm:mt-6 ml-1 font-bold'>Note:</div>
            <ul className='list-disc ml-4 sm:ml-6'>
              <li>
                You can not close this tab once the assessment has started,
                otherwise your assessment will be auto-submitted
              </li>
              {/* <li>
            In case of any network issues,{' '}
            <span className='text-primary underline'>
              please raise a query to the Belong Team
            </span>
          </li> */}
              <li>
                In case of any network issues, please write to the Belong Team
                at{' '}
                <span className='text-primary underline'>
                  connect@belong.education
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className='flex justify-center mt-4 sm:mt-12'>
          <button
            disabled={loading}
            onClick={() => {
              openModal();
            }}
            // onClick={() => {
            //   startAptitude();
            // }}
            className='px-12 py-2 font-semibold text-xl text-primary border border-gray-400 rounded-xl shadow'>
            {loading ? 'Please Wait' : 'Start Test'}
          </button>
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'>
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'>
                <Dialog.Panel className='w-full max-w-4xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all'>
                  <div className='overflow-hidden rounded-lg shadow-[0px_8px_15px_rgba(158,158,158,0.2)] ring-1 ring-black ring-opacity-5'>
                    <div className='relative bg-white space-y-4 p-4 '>
                      {/* disclaimer */}
                      <p
                        onClick={closeModal}
                        className='absolute top-2 right-4 cursor-pointer font-bold '>
                        X
                      </p>
                      <div className=' space-y-2'>
                        <p className='font-semibold'>Note:</p>
                        <p>
                          Ensure your internet connection and device are
                          functioning properly.
                        </p>
                        <p>
                          Find a calm, disturbance-free environment for the next
                          20-25 minutes during the test.
                        </p>
                        <p className='font-medium'>
                          Please be aware that requests to retake the Aptitude
                          Test will not be considered.
                        </p>
                      </div>
                      <div className='text-center'>
                        <button
                          onClick={() => {
                            startAptitude();
                          }}
                          // onClick={() => {
                          //   navigate('aptitude-quiz');
                          // }}
                          className='font-manrope lg:mt-10 mt-6 text-primary font-bold text-xl border-2 border-[#878787]/50 lg:px-10 px-6 py-2 rounded-xl '>
                          Start Aptitude Test
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default GsapAptitudeInstructions;
